var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05086 0.22908C4.74542 -0.0763599 4.24365 -0.0763599 3.95998 0.22908L0.22908 3.95998C-0.0763599 4.26542 -0.0763599 4.76719 0.22908 5.05086L3.95998 8.78176C4.11278 8.93456 4.3091 9 4.50542 9C4.70175 9 4.89806 8.93456 5.05086 8.78176C5.3563 8.47632 5.3563 7.97455 5.05086 7.69088L1.88718 4.50542L5.05071 1.3419C5.3563 1.03646 5.3563 0.534527 5.05086 0.229118L5.05086 0.22908Z",
    fill: "#2A2A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon2);
export default __webpack_public_path__ + "static/media/BackArrowIcon2.a8dea21c6f8f047d2fda2ceaaf17232b.svg";
export { ForwardRef as ReactComponent };